import React, { useEffect, useState } from "react";
import { PaperClip } from "../../../assets/icons";
import NuDateFormat from "../../../utils/NuDate";
import { NormalButton } from "../../../utils/Button";
import useGetCompanyInfo from "../../../hooks/useGetCompanyInfo";
import DecryptData from "../../../utils/Decrypt";
import PDFGenerationScreen from "../PDFGenerationScreen";
import ImplementationSummaryXlsx from "./xlsx/ImplementationSummaryXlsx";
import ImplementationDetailsXlsx from "./xlsx/ImplementationDetailsXlsx";
import InternalAuditSummaryXlxs from "./xlsx/InternalAuditSummary";
import InternalAuditDetailsXlxs from "./xlsx/InternalAuditDetailsXlxs";
import MRMSummaryXlsx from "./xlsx/MRMSummaryXlsx";
import MRMDetailXlsx from "./xlsx/MRMDetailsXlsx";
import AuditXlsx from "./xlsx/AuditXlsx";
import MaintenanceXlsx from "./xlsx/MaintenanceDetailXlsx";
import SecurityXlsx from "./xlsx/SecurityDetailXlsx";
import MasterXlsx from "./xlsx/MasterDetailsXlsx";
import TaskMangementXlsx from "./xlsx/TaskManagementXlsx";
import TrainingXlsx from "./xlsx/TrainingDetailXlsx";
import VendorXlsx from "./xlsx/VendorDetailXlsx";

function ViewReport({ header = [], data = [], showReport = false,standardDetailName, standardStartDate, standardEndDate,review,downloadFileName="sample.pdf",isDataLoading=false,setIsDataLoading=()=>{},format="",module="",view="",status={},standardId="",Name="" }) {
  console.log("Name",Name);
  console.log("standardDetailName",standardDetailName);
  console.log("module",module);
  
  const [pdfUrl, setPdfUrl] = useState(null);
  const userData = localStorage.getItem("aTaDrEsU")?DecryptData("aTaDrEsU"):[];
  const {company}=useGetCompanyInfo()
  useEffect(() => {
    if(header.length>0){
      const worker = new Worker(new URL('./reportPDF.jsx', import.meta.url));
    
 
      worker.onmessage = (e) => {
        setPdfUrl(e.data);
        setTimeout(()=>{
          setIsDataLoading(false);
        },10000)
      };
    

   
      worker.postMessage({
        data,
        company:company,
        standardDetailName,
        review,
        standardStartDate,
        standardEndDate,
        Name: `${Name||""} ${view||""} Report`,
        UserName: userData?.user_name,
        Location: userData?.location || "-",
        Country: userData?.country || "-",
        department: userData?.department || "-",
        header,
        status:Object.keys(status).length>0?status:{},
      });
    

   return () => {
      worker.terminate();
      setTimeout(()=>{
        setIsDataLoading(false);
      },10000)
    }
    }
  }, [data,company]);

  useEffect(()=>{
    if(showReport){

    }else{
      setPdfUrl(null)
      // setIsDataLoading(true)    
    }
    console.log("Show Report",showReport);
  },[showReport])

  return (
    <>
      <div className=" w-full h-auto">
        <div className=" sticky top-0 z-10 bg-white">
          <div className={`w-[75%] float-end flex justify-end items-end mb-2 ${showReport==true ?"-mt-10":""}`} >
          {pdfUrl && showReport==true && format=="pdf" && (
              <a
                href={URL.createObjectURL(pdfUrl)}
                download={downloadFileName}
              >
                <NormalButton label='Download'/>
              </a>
            )} 

            {
              showReport==true && format=="xlsx" && (
                <>
                {
       module == 1 && view=="Summary" ?<ImplementationSummaryXlsx status={status} company={company} standardname={`Standard ${standardDetailName}`} review={review} startDate={standardStartDate} endDate={standardEndDate} Name={`${Name} ${view} Report `} fileName={`${standardDetailName}-Implementation Checklist Detail Report ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`} data={data} Module={Name} standardId={standardId} updateLenth={()=>{}} />
    :module == 1 && view=="Detailed"?<ImplementationDetailsXlsx status={status} company={company} standardname={`Standard ${standardDetailName}`} review={review} startDate={standardStartDate} endDate={standardEndDate} Name={`${Name} ${view} Report `}  fileName={`${standardDetailName}-Implementation Checklist Summary Report ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`} data={data} updateLenth={()=>{}} />
    :module == 2 && view=="Summary" ?<InternalAuditSummaryXlxs status={status} company={company} standardname={`Standard ${standardDetailName}`} review={review} startDate={standardStartDate} endDate={standardEndDate} Name={`${Name} ${view} Report `} fileName={`${standardDetailName}-Internal Audit Detail Report ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`} data={data} updateLenth={()=>{}} />
    :module == 2 && view=="Detailed"?<InternalAuditDetailsXlxs  status={status} company={company} standardname={`Standard ${standardDetailName}`} review={review} startDate={standardStartDate} endDate={standardEndDate} Name={`${Name} ${view} Report `} fileName={`${standardDetailName}-Internal Audit Summary Report ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`} data={data} updateLenth={()=>{}} />
    :module == 18 && view=="Summary" ?<MRMSummaryXlsx status={status} company={company} standardname={`Standard ${standardDetailName}`} review={review} startDate={standardStartDate} endDate={standardEndDate} Name={`${Name} ${view} Report `} fileName={`${standardDetailName}-CISO/MRM Meeting Detail Report ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`} data={data} updateLenth={()=>{}} />
    :module == 18 && view=="Detailed"?<MRMDetailXlsx status={status} company={company} standardname={`Standard ${standardDetailName}`} review={review} startDate={standardStartDate} endDate={standardEndDate} Name={`${Name} ${view} Report `} fileName={`${standardDetailName}-CISO/MRM Meeting Summary Report ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`} data={data} updateLenth={()=>{}} />
    :module == 6?<AuditXlsx status={status} company={company} standardname={`Standard ${standardDetailName}`} review={review} startDate={standardStartDate} endDate={standardEndDate} Name={`${Name} ${view} Report `}  fileName={`${standardDetailName}-Audit Report ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`} data={data} updateLenth={()=>{}}/>
    :module == 3?<MaintenanceXlsx status={status} company={company} standardname={`Standard ${standardDetailName}`} review={review} startDate={standardStartDate} endDate={standardEndDate} Name={`${Name} ${view} Report `} fileName={`${standardDetailName}-Maintenance Report ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`} data={data} updateLenth={()=>{}}/>
    :module == 4?<MasterXlsx status={status} company={company} standardname={`Standard ${standardDetailName}`} review={review} startDate={standardStartDate} endDate={standardEndDate} Name={`${Name} ${view} Report `} fileName={`${standardDetailName}-Master List Of Documents Report ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`} data={data} updateLenth={()=>{}}/>
    :module == 12?<SecurityXlsx status={status} company={company} standardname={`Standard ${standardDetailName}`} review={review} startDate={standardStartDate} endDate={standardEndDate} Name={`${Name} ${view} Report `} fileName={`${standardDetailName}-Security Incident Report ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`} data={data}  updateLenth={()=>{}}/>
    :module == 10?<TaskMangementXlsx status={status} company={company} standardname={`Standard ${standardDetailName}`} review={review} startDate={standardStartDate} endDate={standardEndDate} Name={`${Name} ${view} Report `} fileName={`${standardDetailName}-Task Management Report ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`} data={data} updateLenth={()=>{}}/>
    :module == 16?<TrainingXlsx status={status} company={company} standardname={`Standard ${standardDetailName}`} review={review} startDate={standardStartDate} endDate={standardEndDate} Name={`${Name} ${view} Report `} fileName={`${standardDetailName}-Training Calendar Report ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`} data={data} updateLenth={()=>{}}/>
    :module == 11?<VendorXlsx status={status} company={company} standardname={`Standard ${standardDetailName}`} review={review} startDate={standardStartDate} endDate={standardEndDate} Name={`${Name} ${view} Report `}  fileName={`${standardDetailName}-Vendor Management Report ${standardStartDate && NuDateFormat({value:standardStartDate, format:"MMM-YYYY"})} ${standardEndDate && "to"} ${standardEndDate && NuDateFormat({value:standardEndDate,format:"MMM-YYYY"})}`} data={data} updateLenth={()=>{}}/>
    :""
  }   
                </>
              )
            }
          </div>
          
          <table className="table-auto w-full">
            <thead className="bg-tabletitle">
              <tr className="flex items-center text-xs 2xl:text-sm ">
                {header?.map((item) => (
                  <th
                    className={`py-2 ${item.width || ''} text-${item.headerAlign || 'left'} font-medium text-xs  2xl:text-sm`}
                  >
                    {item?.label}
                  </th>
                ))}
              </tr>
            </thead>
          </table>
        </div>
        <div>
          <table className="table-auto w-full">
            <tbody className="divide-y divide-gray-200">
              {data.length > 0 ? (
                data?.map((item, index) => (
                  <tr
                    className="odd:bg-tableodd even:bg-tableeven text-xs 2xl:text-sm "
                    key={index}
                  >
                    {header?.map((headerItem) => (
                      <td
                        key={headerItem.fieldname}
                        className={` ${headerItem?.type === "file"?"py-2":"py-4"}  ${
                          headerItem?.rowAlign || "text-center"
                        } ${headerItem.width} ${(headerItem.label === "Status" || headerItem.label ==="Status Update")&& "capitalize"} `}
                      >
                        {headerItem.type === "file" &&
                        item[headerItem.fieldname] ? (
                          <div className=" w-full flex justify-center">
                            <PaperClip />
                          </div>
                        ) : headerItem.type === "date" &&
                          item[headerItem.fieldname] !== "None" ? (
                          NuDateFormat({
                            value:
                              item[headerItem.fieldname] ||
                              item[headerItem.feildnametwo],
                            format: "DD-MMM-yyyy",
                          }) || "-"
                        ):headerItem.type === "module" ?(
                          <>
                          {item[headerItem.fieldname] == 1
                            ? "Implementation Checklist"
                            : item[headerItem.fieldname] == 2
                            ? "Internal Audit"
                            : item[headerItem.fieldname] == 3
                            ? "Maintenance"
                            : item[headerItem.fieldname] == 4
                            ? "Master List of Documents"
                            : item[headerItem.fieldname] == 18
                            ? "CISO / MRM Meeting"
                            : item[headerItem.fieldname] == 6
                            ? "Audit Schedule"
                            : item[headerItem.fieldname] == 12
                            ? "Security Incident"
                            : item[headerItem.fieldname] == 16
                            ? "Training Calendar"
                            : " "}
                          </>
                        )
                        : (
                          item[headerItem.fieldname] ||
                          item[headerItem.feildnametwo] ||
                          item[headerItem.feildnamethree] ||
                          " "
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr className="w-full">
                  <td colSpan={header.length-1}  className={` w-full text-center  font-semibold py-9 `}>
                    No Data 
                  </td>
                  </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
          <PDFGenerationScreen visible={ format=="pdf"?isDataLoading:false} activity={Name} format={format} name={standardDetailName}/>
    </>
  );
}

export default ViewReport;
